import React from "react";
import useFormFlow from "modules/forms/hooks/useFormFlow";
import { FormBlockType } from "modules/forms/hooks/usefetchForm";
import BlockWrapper from "modules/forms/embedded/blocks/BlockWrapper";

export type AddToWalletQrCodeBlockType = Omit<FormBlockType, "data"> & {
    data: {
        width: number;
    },
}

export default function AddToWalletQrCodeBlock(block: AddToWalletQrCodeBlockType) {
    const { contact } = useFormFlow();
    const { width } = block.data;
    const addToWalletUrl = contact?.add_to_wallet_url;
    const source = `https://api.qrserver.com/v1/create-qr-code/?size=500x500&margin=20&data=${addToWalletUrl}`;

    return (
        <BlockWrapper name={block.name} hidden={false}>
            <img
                alt={"qr-code"}
                src={source}
                style={{ width: width + "%" }}
            />
        </BlockWrapper>
    );
}
